import React from 'react'
import A from '../../A'
import styles from './SearchComponent.module.scss'

import searchIcon from './search.svg'
import cancelIcon from './cancel.svg'
class SearchComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = { focus: false }
  }
  render() {
    const {
      text,
      onChange,
      size,
      openPopup,
      reset
    } = this.props
    const { focus } = this.state
    return (
      <div className={styles.container + ` ` + (focus ? styles.focus : ``)}>
        <input
          type="text"
          value={text}
          onChange={onChange}
          onFocus={() => this.setState({focus: true })}
          onBlur={() => this.setState({ focus: false })}
          placeholder="FAI UNA RICERCA"
        />
        
        {
          text.length !== 0 ? 
            <A><img src={cancelIcon} className={styles.hoverable} onClick={() => reset()} /></A> : <img src={searchIcon} />
        }
        {
          size === 0 ? <A><button
            className={`primary ` + styles.apply}
            onClick={() => openPopup(
              text,
              "",
              [],
              'c'
            )}
          >
            Applica
      </button></A> : <noscript />
        }
      </div>
    )
  }
}


export default SearchComponent